import QcIcon from '../../assets/icons/qc/logo.svg';
import { Box, Image, Stack, Text, styled } from '@qcx/ui';
import { Link } from '../Link';
import { MenuItem } from './shell.store';

export const QcMenu = () => {
  const fdo_header = {
    active: true,
    items: [
      {
        title: 'Questões',
        href: 'https://www.qconcursos.com/questoes-de-concursos/questoes',
        event: 'fdo header questions clicked',
        props: {
          target: '_blank'
        }
      },
      {
        title: 'Guias de estudos',
        href: 'https://www.qconcursos.com/questoes-de-concursos/guias/organize-seus-estudos',
        event: 'fdo header study guide clicked',
        props: {
          target: '_blank'
        }
      },
      {
        title: 'Provas',
        href: 'https://www.qconcursos.com/questoes-de-concursos/provas',
        event: 'fdo header tests clicked',
        props: {
          target: '_blank'
        }
      }
    ],
    cta: {
      title: 'Estude grátis',
      href: 'https://www.qconcursos.com/conta/cadastrar',
      event: 'fdo header register clicked',
      props: {
        target: '_blank'
      }
    }
  };

  if (!fdo_header.active) {
    return <></>;
  }

  return (
    <>
      <StyleLine />
      <Stack
        css={{
          bgColor: '$neutral50',
          rounded: '$4xl',
          py: '$6',
          px: '$6',
          mx: '$4',
          my: '$4'
        }}
        flow="column"
        gap="$6"
      >
        <Stack gap="$3">
          <Box css={{ w: 24, h: 24 }}>
            <StyledIcon
              width={24}
              height={24}
              alt="Logo Qconcursos"
              src={QcIcon}
              noAspectRatio
              priority
            />
          </Box>
          <Link
            css={{
              color: '$neutral700'
            }}
            target="_blank"
            to="https://www.qconcursos.com/"
          >
            <Text variant="sm" weight="medium">
              Ir para o Qconcursos
            </Text>
          </Link>
        </Stack>
        {fdo_header.items.map((menu: MenuItem, idx: number) => (
          <Link
            key={`menu_${idx}`}
            css={{
              color: '$neutral700'
            }}
            title={`Qconcursos: ${menu.title}`}
            to={menu.href}
            {...menu.props}
            onClick={() => menu.event}
          >
            <Text variant="sm" weight="medium">
              {menu.title}
            </Text>
          </Link>
        ))}
        <StyledButtonSignIn
          tabIndex={0}
          to={fdo_header.cta.href}
          {...fdo_header.cta.props}
          onClick={() => fdo_header.cta.event}
        >
          {fdo_header.cta.title}
        </StyledButtonSignIn>
      </Stack>
    </>
  );
};

const StyledIcon = styled(Image, {
  '& img': {
    h: 24,
    w: 24,
    objectFit: 'contain'
  }
});

const StyledButtonSignIn = styled(Link, {
  bgColor: '$secondary500',
  fontWeight: '$bold',
  fontSize: '$sm',
  minW: '$9',
  minH: '$9',
  h: '$9',
  rounded: '$lg',
  p: '$3dot5',
  lineHeight: '$sm ',
  d: 'flex',
  flexCenter: true,
  color: '$bodyBg',
  '&:hover, &:active': {
    bgColor: '#FE6112',
    color: '$bodyBg'
  }
});

const StyleLine = styled('hr', {
  height: 1,
  width: '100%',
  backgroundColor: '$separatorColor'
});
